import { render, staticRenderFns } from "./chooseProducts.vue?vue&type=template&id=6d1e942c&scoped=true"
import script from "./chooseProducts.vue?vue&type=script&lang=js"
export * from "./chooseProducts.vue?vue&type=script&lang=js"
import style0 from "./chooseProducts.vue?vue&type=style&index=0&id=6d1e942c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1e942c",
  null
  
)

export default component.exports